import React from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import LogoName from "./Logo";
import AuthCircle from "./AuthCircle";

class Header extends React.Component {
    render() {
        const { drawerWidth } = this.props;

        return (
            <Box sx={{ flexGrow: 1 }}>
                <AppBar
                    position="fixed"
                    sx={{
                        /* replace solid bgcolor with a diagonal gradient */
                        background: theme =>
                            `linear-gradient(
                 to bottom right,
                 ${theme.palette.primary.dark} 0%,
                 ${theme.palette.primary.main} 100%
               )`,
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        ml: { sm: `${drawerWidth}px` },
                    }}
                >
                    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <LogoName />
                        <Box sx={{ ml: 'auto', mr: '10%' }}>
                            <AuthCircle />
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
        );
    }
}

export default Header;
